import React from 'react';
import { TRANSIT_CONNECTOR } from '@/constants/testIds';
import { Footprints, Train, Car, Bus } from 'lucide-react';

const MODE_META = {
    walk: { icon: Footprints, label: 'walk' },
    subway: { icon: Train, label: 'by subway' },
    train: { icon: Train, label: 'by train' },
    taxi: { icon: Car, label: 'by taxi' },
    car: { icon: Car, label: 'by car' },
    bus: { icon: Bus, label: 'by bus' },
};

function normalizeMode(raw) {
    if (!raw || typeof raw !== 'string') return null;
    const m = raw.trim().toLowerCase();
    if (MODE_META[m]) return m;
    if (m.includes('walk')) return 'walk';
    if (m.includes('subway') || m.includes('metro') || m.includes('mrt')) return 'subway';
    if (m.includes('train') || m.includes('rail')) return 'train';
    if (m.includes('taxi') || m.includes('uber') || m.includes('grab')) return 'taxi';
    if (m.includes('bus') || m.includes('coach')) return 'bus';
    if (m.includes('car') || m.includes('drive')) return 'car';
    return null;
}

export default function TransitConnector({ minutes, mode }) {
    const m = Number(minutes);
    if (!Number.isFinite(m) || m <= 0) return null;
    const normalized = normalizeMode(mode);
    const meta = normalized ? MODE_META[normalized] : { icon: Footprints, label: '' };
    const Icon = meta.icon;
    const label = `~${Math.round(m)} min${meta.label ? ` ${meta.label}` : ''}`;
    return (
        <div
            data-testid={TRANSIT_CONNECTOR.root}
            className="flex items-center gap-2 pl-[44px] sm:pl-[60px] py-1 select-none"
            aria-label={`Transit to next activity: ${label}`}
        >
            <span
                className="h-6 w-px border-l border-dashed flex-shrink-0"
                style={{ borderColor: 'var(--ns-border)' }}
            />
            <span
                className="inline-flex items-center gap-1.5 text-[11px] text-[var(--ns-text3)] uppercase tracking-widest"
            >
                <Icon size={12} />
                {label}
            </span>
            <span
                className="flex-1 border-t border-dashed"
                style={{ borderColor: 'var(--ns-border)' }}
            />
        </div>
    );
}
